import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../App";
import {
  LayoutDashboard,
  ArrowUpDown,
  ShoppingCart,
  Users,
  Wallet,
  BarChart3,
  Building2,
  LogOut,
  Menu,
  X,
  CreditCard
} from "lucide-react";
import { useState } from "react";

const navItems = [
  { path: "/dashboard", label: "Özet", icon: LayoutDashboard },
  { path: "/odeme-yonetimi", label: "Ödeme Yönetimi", icon: CreditCard },
  { path: "/gelir-gider", label: "Gelir / Gider", icon: ArrowUpDown },
  { path: "/satislar", label: "Satışlar", icon: ShoppingCart },
  { path: "/cari-hesaplar", label: "Cari Hesaplar", icon: Users },
  { path: "/tahsilatlar", label: "Tahsilatlar", icon: Wallet },
  { path: "/raporlar", label: "Raporlar", icon: BarChart3 },
  { path: "/profil", label: "Şirket Profili", icon: Building2 },
];

const Layout = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="flex min-h-screen bg-[#F7F7F8]" data-testid="main-layout">
      {/* Mobile Menu Button */}
      <button
        className="lg:hidden fixed top-4 left-4 z-50 p-2 bg-white border border-[#E4E4E7] rounded-sm"
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        data-testid="mobile-menu-btn"
      >
        {mobileMenuOpen ? <X size={20} /> : <Menu size={20} />}
      </button>

      {/* Sidebar */}
      <aside
        className={`
          fixed lg:static inset-y-0 left-0 z-40 w-64 border-r border-[#E4E4E7] bg-[#F7F7F8] 
          transform transition-transform duration-200 ease-in-out
          ${mobileMenuOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
        `}
        data-testid="sidebar"
      >
        <div className="flex flex-col h-full">
          {/* Logo */}
          <div className="p-6 border-b border-[#E4E4E7]">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-[#002FA7] rounded-sm flex items-center justify-center">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                </svg>
              </div>
              <div>
                <span className="font-heading font-bold text-[#0A0A0B] block">FinansKontrol</span>
                <span className="text-xs text-[#5E5E62]">{user?.company_name || "OTO YEDEK PARÇA"}</span>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <nav className="flex-1 py-4 overflow-y-auto">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                onClick={() => setMobileMenuOpen(false)}
                data-testid={`nav-${item.path.replace('/', '')}`}
                className={({ isActive }) =>
                  isActive ? "nav-item-active" : "nav-item"
                }
              >
                <item.icon size={20} />
                <span>{item.label}</span>
              </NavLink>
            ))}
          </nav>

          {/* User Info & Logout */}
          <div className="p-4 border-t border-[#E4E4E7]">
            <div className="flex items-center gap-3 px-2 mb-3">
              {user?.picture ? (
                <img
                  src={user.picture}
                  alt={user.name}
                  className="w-8 h-8 rounded-full"
                />
              ) : (
                <div className="w-8 h-8 bg-[#002FA7] rounded-full flex items-center justify-center text-white text-sm font-medium">
                  {user?.name?.charAt(0) || "U"}
                </div>
              )}
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-[#0A0A0B] truncate">{user?.name}</p>
                <p className="text-xs text-[#5E5E62] truncate">{user?.email}</p>
              </div>
            </div>
            <button
              onClick={handleLogout}
              data-testid="logout-btn"
              className="w-full flex items-center gap-3 px-4 py-2 text-sm font-medium text-[#FF3B30] hover:bg-[#FFEBEE] rounded-sm transition-colors"
            >
              <LogOut size={18} />
              <span>Çıkış Yap</span>
            </button>
          </div>
        </div>
      </aside>

      {/* Mobile Overlay */}
      {mobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black/20 z-30 lg:hidden"
          onClick={() => setMobileMenuOpen(false)}
        />
      )}

      {/* Main Content */}
      <main className="flex-1 min-h-screen lg:ml-0">
        {children}
      </main>
    </div>
  );
};

export default Layout;
